import UmlShape from './UmlShape';

// Single sequence-diagram message: horizontal arrow between two lifelines at
// a row-y. x/y/w/h are kept in sync by CsSeqDiaRelationHandler whenever
// either endpoint participant moves, or clamped (see
// CsSeqDiaRelationHandler.clampSeqMessageY) whenever the message itself is
// dragged vertically. `label` is a UmlCaption (same as UmlClassShape.caption
// or a UmlConnector's label) \u2014 x/y are a DRAG OFFSET relative to this
// shape's own x/y, independently movable like a connector label, NOT baked
// into the arrow's own rendering. Text already includes the "(boundary)"
// suffix / return-type wording at construction time (see
// CsSeqCanvasLayoutBuilder) \u2014 this shape doesn't reformat it.
// pairedMessageId links a call to its own matching return (and vice versa)
// so a drag can be clamped so a call never sinks below its own return, or a
// return rises above its own call. rowIndex is this message's position in
// CsSeqShapeFactory's original call/return event order \u2014 used by
// CsSeqDiaRelationHandler's nested-group-move to work out which OTHER
// messages/activations sit temporally "inside" this one's own call/return
// span and must shift along with it.
class UmlSeqMessageShape extends UmlShape {
  constructor(id, x, y, w, h, fromX, toX, label, boundary, fromParticipantId, toParticipantId, isReturn = false, pairedMessageId = null, rowIndex = 0, params = undefined) {
    super(id, x, y, w, h);
    this.fromX = fromX;
    this.toX = toX;
    this.label = label; // UmlCaption
    this.boundary = Boolean(boundary);
    this.isReturn = Boolean(isReturn);
    this.fromParticipantId = fromParticipantId;
    this.toParticipantId = toParticipantId;
    this.pairedMessageId = pairedMessageId;
    this.rowIndex = rowIndex;
    this.params = params; // structured {name,type}[] for a call message, undefined for a return — see UmlCanvasEngine/CsSeqOrchestrator for where this is captured at generate time
    this.kind = 'seq-message'; // discriminant voor UmlShapeSerializer.fromPlainShape
  }
}

export default UmlSeqMessageShape;
